import Crud from '@/stores/crudBase';
import api from '@/apis/opening/openingInventoryEntryAPI.js';
var crud = new Crud('openingInventoryEntry', api);

const state = {
  ...crud.state,
  _config: {
    table: 'opening_inventory_entry',
    field: {
      code: 'inventory_item_code',
      name: 'inventory_item_name',
      key: 'ref_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Lấy dữ liệu số dư vật tư hàng hóa chi tiết
   * @param {*} context
   * @param {*} payload
   * @returns
   * NVTUAN1 20.09.2022
   */
  async getOpeningInventory(context, payload) {
    return await api.getOpeningInventory(payload || {});
  },

  /**
   * Thêm hoặc cập nhật số dư tồn kho vật tư hàng hóa
   * @param {*} context
   * @param {*} param
   * @returns
   * NVTUAN1 21.09.2022
   */
  async saveOpeningInventory(context, param) {
    let res = await api.saveOpeningInventory(param);
    return res;
  },

  /**
   * Xóa số dư tồn kho vật tư hàng hóa
   * NVTUAN1 28.09.2022
   */
  async deleteOpeningInventory(context, payload) {
    let filters = [];

    payload?.Models?.forEach(x => {
      filters.push({
        account_number: x.account_number,
        inventory_item_id: x.inventory_item_id,
        stock_id: x.stock_id,
      });
    });

    let res = await api.deleteOpeningInventory(filters || []);

    let errValidate = ['VALIDATE', 'Business', 'Exception'];
    let keyField = context.state._config.field.key;
    //Danh sách gửi lên xóa
    let deleted = [...payload.Models];
    if (keyField && res) {
      for (let i = 0; i < res.length; i++) {
        // Nếu không xóa được thì loại bỏ khỏi list xóa
        if (errValidate.find(x => x === res[i]?.Code)) {
          if (res[i] && res[i].Data && res[i].Data.Data) {
            let itemError = payload.Models[res[i].Index];
            //Loại đi những bản ghi không xóa được
            deleted = deleted.filter((item, index) => {
              return !(item[keyField] === res[i].Data.Data[keyField] || item[keyField] === itemError[keyField]);
            });
          }
        }
      }
    }
    //Commit thực hiện xóa
    context.commit('deleteItems', deleted);

    return res;
  },

  /**
   * Lấy thông tin detail vthh
   * pthai - 31/07/2023
   */
  async getListDetail(context, param) {
    let res = await api.getListDetail(param);
    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
